const LEADING_DIGITS = /^\d+/;

/** Stable natural ordering for catalog codes such as `U1`, `U2`, `U10`, `U1S3`. */
export function compareCatalogCodes(a: string, b: string): number {
  if (a === b) {
    return 0;
  }

  const tokensA = catalogCodeTokens(a);
  const tokensB = catalogCodeTokens(b);
  const length = Math.max(tokensA.length, tokensB.length);

  for (let i = 0; i < length; i++) {
    if (i >= tokensA.length) {
      return -1;
    }
    if (i >= tokensB.length) {
      return 1;
    }

    const tokenA = tokensA[i];
    const tokenB = tokensB[i];
    if (tokenA === tokenB) {
      continue;
    }

    if (typeof tokenA === "number" && typeof tokenB === "number") {
      return tokenA - tokenB;
    }

    return String(tokenA).localeCompare(String(tokenB));
  }

  return 0;
}

function catalogCodeTokens(value: string): Array<string | number> {
  const tokens: Array<string | number> = [];
  let index = 0;
  while (index < value.length) {
    const rest = value.slice(index);
    const digitMatch = rest.match(LEADING_DIGITS);
    if (digitMatch) {
      tokens.push(Number.parseInt(digitMatch[0], 10));
      index += digitMatch[0].length;
      continue;
    }

    const nextDigit = rest.search(/\d/);
    const end = nextDigit === -1 ? value.length : index + nextDigit;
    tokens.push(value.slice(index, end));
    index = end;
  }
  return tokens;
}
